var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("首页")]),
            _c("el-breadcrumb-item", [_vm._v("反馈管理")]),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { name: "feedbackList" } } },
              [_vm._v("反馈列表")]
            ),
            _c("el-breadcrumb-item", [_vm._v("反馈详情")]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "hx-form-container box-shadow" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.formLoading,
              expression: "formLoading",
            },
          ],
          staticClass: "feedback-box",
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { width: "95%" },
              attrs: { model: _vm.detailParams, "label-width": "120px" },
            },
            [
              _c("el-form-item", { attrs: { label: "反馈用户：" } }, [
                _c("span", [_vm._v(_vm._s(_vm.detailParams.creator))]),
              ]),
              _c("el-form-item", { attrs: { label: "反馈时间：" } }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm._f("formatDate")(_vm.detailParams.publishTime, true)
                    )
                  ),
                ]),
              ]),
              _c("el-form-item", { attrs: { label: "反馈标题：" } }, [
                _c("span", [_vm._v(_vm._s(_vm.detailParams.title))]),
              ]),
              _c("el-form-item", { attrs: { label: "反馈内容：" } }, [
                _c("p", [_vm._v(_vm._s(_vm.detailParams.content))]),
              ]),
              _c("el-form-item", { attrs: { label: "反馈模块：" } }, [
                _c("span", [_vm._v(_vm._s(_vm.detailParams.category))]),
              ]),
              _c("el-form-item", { attrs: { label: "接收单位：" } }, [
                _c("span", [_vm._v(_vm._s(_vm.detailParams.receiver))]),
              ]),
              _vm.detailParams.imageUrlList
                ? _c(
                    "el-form-item",
                    { attrs: { label: "回复截图：" } },
                    _vm._l(
                      _vm.detailParams.imageUrlList,
                      function (img, index) {
                        return _c("el-image", {
                          key: index,
                          staticStyle: {
                            width: "100px",
                            height: "100px",
                            "margin-right": "10px",
                          },
                          attrs: {
                            src: img,
                            "preview-src-list": _vm.detailParams.imageUrlList,
                          },
                        })
                      }
                    ),
                    1
                  )
                : _vm._e(),
              _vm._l(_vm.detailParams.msgList, function (item, index) {
                return _c(
                  "div",
                  { key: index },
                  [
                    _c("div", { staticClass: "division-cut-line" }),
                    _c("el-form-item", { attrs: { label: "回复时间：" } }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("formatDate")(item.publishTime, true))
                        ),
                      ]),
                    ]),
                    _c("el-form-item", { attrs: { label: "回复人：" } }, [
                      _c("span", [_vm._v(_vm._s(item.sender))]),
                    ]),
                    _c("el-form-item", { attrs: { label: "回复内容：" } }, [
                      _c("span", [_vm._v(_vm._s(item.content))]),
                    ]),
                    item.imageUrlList
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "回复截图：" } },
                          _vm._l(item.imageUrlList, function (img, index) {
                            return _c("el-image", {
                              key: index,
                              staticStyle: {
                                width: "100px",
                                height: "100px",
                                "margin-right": "10px",
                              },
                              attrs: {
                                src: img,
                                "preview-src-list": item.imageUrlList,
                              },
                            })
                          }),
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _c("div", { staticClass: "division-cut-line" }),
              _c(
                "el-form-item",
                {
                  staticStyle: { position: "relative" },
                  attrs: { label: "回复：", prop: "content" },
                },
                [
                  _c("el-input", {
                    staticClass: "mgb10",
                    attrs: {
                      type: "textarea",
                      row: 6,
                      placeholder: "请输入回复内容",
                    },
                    model: {
                      value: _vm.content,
                      callback: function ($$v) {
                        _vm.content = $$v
                      },
                      expression: "content",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass: "reply-btn",
                      attrs: { disabled: _vm.isDisabled, type: "text" },
                      on: { click: _vm.replyFeedback },
                    },
                    [_vm._v(" 回 复 ")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "mgt20 align-center" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({ name: "feedbackList" })
                        },
                      },
                    },
                    [_vm._v(" 返 回 ")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }